import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';
import { PrivateRoute } from './util/auth';
import { IntlProvider, addLocaleData } from 'react-intl';

import { LocaleProvider } from 'antd';

import en from 'react-intl/locale-data/en';
import zh from 'react-intl/locale-data/zh';
import 'moment/locale/zh-cn';

import { setItem, getItem } from 'Util/util';
import qs from 'qs';

import {
  Login,
  NotFound,
  Component as ComponentPage
} from './pages/loadablePage';

import zhCN from './locales/zh-CN';
import enUS from './locales/en-US';

import { routes } from './stories/routes';
import { getLocales } from './components/common/locales';

addLocaleData([...en, ...zh]);

const basename = window.pwConfig[process.env.NODE_ENV].basename;

class App extends Component {
  constructor(props) {
    super(props);
    const { resid: resId } = this.resolveQueryString();

    this.state = {
      warningBarVisible: true,
      resId,
      desktopStyle: null
    };
  }

  resolveQueryString = () => {
    const querystring = window.location.search.substring(1);
    return qs.parse(querystring);
  };

  componentDidMount = () => {
    // 国际化
    let userInfo,
      language = '中文';
    try {
      userInfo = JSON.parse(getItem('userInfo'));
      if (!userInfo) {
        language = getItem('language') || '中文';
        setItem('language', language);
      } else {
        language = userInfo.UserInfo.EMP_LANGUAGE;
      }
    } catch (err) {}

    language = getItem('language') || '中文';

    this.setState({
      userInfo,
      language
    });
  };

  render() {
    const { language } = this.state;
    const locales = getLocales(language, {
      zh: zhCN,
      en: enUS
    });

    return (
      <LocaleProvider locale={locales.localeAntd}>
        <IntlProvider locale={locales.locale} messages={locales.messages}>
          <Router basename={basename || '/'}>
            <Switch>
              <PrivateRoute
                exact
                path="/"
                component={() => (
                  <Redirect
                    to={{
                      pathname: '/component/overview'
                    }}
                  />
                )}
              ></PrivateRoute>

              <PrivateRoute
                path="/component"
                component={ComponentPage}
              ></PrivateRoute>

              {routes.map(({ path, component }) => (
                <PrivateRoute
                  key={path}
                  path={path}
                  component={component}
                ></PrivateRoute>
              ))}

              <Route path="/login" component={Login} />
              <Route path="*" component={NotFound} />
            </Switch>
          </Router>
        </IntlProvider>
      </LocaleProvider>
    );
  }
}

export default App;
